import { Button, message, Popconfirm } from 'antd'
import React, { FunctionComponent, useCallback } from 'react'

import { useDeleteLabelMutation } from '../../../graphql/generated'
import { EditLabelButton } from '../../components/EditLabelButton/EditLabelButton'
import { LabelTableItem } from '../../components/LabelTable/LabelTable'
import { LabelDetail } from '../../utils/labelsTypes'

interface LabelDetailPageExtraProps {
  label: LabelDetail
  refetch?: () => void
}
const styles = { body: { width: '230px' } }

export const LabelDetailPageExtra: FunctionComponent<LabelDetailPageExtraProps> =
  ({ label, refetch }) => {
    const [, deleteLabelById] = useDeleteLabelMutation()

    const handleDeleteLabel = useCallback(() => {
      deleteLabelById({ id: label?.id || '' })
        .then(() => {
          message.success('Štítek byl smazán.')
        })
        .catch(() => {
          message.error('Štítek se nepodařilo smazat.')
        })
    }, [deleteLabelById, label?.id])

    if (!label?.id) return null

    return (
      <div className="flex space-x-2">
        <EditLabelButton
          initialLabel={label as LabelTableItem}
          refetch={refetch}
        />
        <Popconfirm
          title={`Opravdu chcete smazat štítek "${label?.name}"?`}
          onConfirm={handleDeleteLabel}
          okText="Smazat štítek"
          okType="danger"
          cancelText="Zrušit"
          styles={styles}
        >
          <Button ghost danger className="w-full">
            Smazat
          </Button>
        </Popconfirm>
      </div>
    )
  }
